import React, { Component } from 'react';
import { Button, ButtonToolbar, Form, FormGroup, ControlLabel, Modal, FormControl, Row, Col, HelpBlock } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from 'react-select';
import { Map, TileLayer, Circle, FeatureGroup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';

export class MessageForm extends Component {

    renderLines(messageSelected, availableLines) {
        //If it is a transport authority
        if (this.props.isAT) {
            //If no provider is selected, display no lines
            if (undefined === messageSelected.provider || '' === messageSelected.provider) {
                return (
                    <FormControl componentClass="select" value={typeof messageSelected.line !== 'undefined' ? messageSelected.line.id : ""} onChange={(e) => this.props.onChangeValue(e, 'line')}>
                        <option key={`line-provider-undefined`}>Selecione um operador</option>);
                    </FormControl>
                );
            }
            //Find out which provider is selected and which lines belong to it
            else {
                let selectedProvider = this.props.availableProviders.filter(p => parseInt(p.id, 10) === parseInt(messageSelected.provider.id, 10))[0];
                let providerLines = this.props.availableLines.filter(l => l.provider.id === parseInt(selectedProvider.id, 10));
                return (
                    <FormControl componentClass="select" value={typeof messageSelected.line !== 'undefined' ? messageSelected.line.id : ""} onChange={(e) => this.props.onChangeValue(e, 'line')}>
                        <option key={`line-undefined`}>Selecione uma linha</option>
                        {
                            providerLines.sort((a, b) => a.goName !== b.goName ? a.goName < b.goName ? -1 : 1 : 0).map((line, idx) =>
                                <option key={`line-${idx}`} value={line.id}>{`${line.goName} (${line.code})`}</option>
                            )
                        }
                    </FormControl>
                );

            }
        }
        //If it is a provider, availableLines will only have the provider lines, so no special filtering is necessary
        else {
            return (
                <FormControl componentClass="select" value={typeof messageSelected.line !== 'undefined' ? messageSelected.line.id : ""} onChange={(e) => this.props.onChangeValue(e, 'line')}>
                    <option key={`line-undefined`}>Selecione uma linha</option>
                    {
                        availableLines.sort((a, b) => a.goName !== b.goName ? a.goName < b.goName ? -1 : 1 : 0).map((line, idx) =>
                            <option key={`line-${idx}`} value={line.id}>{`${line.goName} (${line.code})`}</option>
                        )
                    }
                </FormControl>
            );
        }
    }

    renderPathStops(messageSelected, availablePathStops) {
        //If no line is selected, display no stops
        if (messageSelected.line === undefined || messageSelected.line === "") {
            return (
                <FormControl componentClass="select" value={typeof messageSelected.stop !== 'undefined' ? messageSelected.stop.id : ""} onChange={(e) => this.props.onChangeValue(e, 'stop')}>
                    <option key={`stop-line-undefined`}>Selecione uma linha</option>);
                </FormControl>
            );
        }
        //Find out which stops belong to the selected line paths
        else {
            let lineStops = []
            //Filter by pathStops belonging to line paths and adding the distinct stops that will be shown to the user to the lineStops array
            availablePathStops.map(ps => -1 !== messageSelected.line.paths.findIndex(p => p.id === ps.path.id)
                ? -1 === lineStops.findIndex(s => s.id === ps.stop.id)
                    ? lineStops.push(ps.stop)
                    : null
                : null
            );

            return (
                <FormControl componentClass="select" value={typeof messageSelected.stop !== 'undefined' ? messageSelected.stop.id : ""} onChange={(e) => this.props.onChangeValue(e, 'stop')}>
                    <option key={`stop-undefined`}> Selecione uma paragem</option >
                    {
                        lineStops.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0).map((stop, idx) =>
                            <option key={`stop-${idx}`} value={stop.id}>{`${stop.name} (${stop.code})`}</option>
                        )
                    }
                </FormControl>
            );
        }
    }

    calculateBounds(messageSelected) {
        if (0 !== messageSelected.coordX && 0 !== messageSelected.coordY) {
            return [{ lat: messageSelected.coordX, lng: messageSelected.coordY }];
        } else {
            return [{ lat: -90, lng: -180 }, { lat: 90, lng: 180 }];
        }
    }

    calculateCircleCenter(messageSelected) {
        if (0 !== messageSelected.coordX && 0 !== messageSelected.coordY) {
            return [messageSelected.coordX, messageSelected.coordY];
        } else {
            return [0, 0];
        }
    }

    render() {
        let { title, messageSelected, availableLines, availablePathStops, availablePlatforms, isAT, availableProviders, startDateInputError, endDateInputError, platformInputError, typeInputError, textInputError
        } = this.props;

        //Needed for react-select to have the complete current list of message.Platforms
        let selectDefaultValue = [];
        if (undefined !== messageSelected) {
            messageSelected.platforms.forEach(p => {
                let aux = { value: p.id, label: `${p.name}` };
                selectDefaultValue.push(aux);
            });
        }

        return (
            typeof messageSelected !== 'undefined'
                ?
                <Modal show={this.props.show}>
                    <Modal.Header>
                        <Modal.Title>
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            {
                                isAT && availableProviders.length > 0 ?
                                    <FormGroup controlId="formProvider">
                                        <ControlLabel>Operador</ControlLabel>
                                        <FormControl componentClass="select" value={typeof messageSelected.provider !== 'undefined' ? messageSelected.provider.id : ""} onChange={(e) => this.props.onChangeValue(e, 'provider')}>
                                            <option key={`provider-undefined`}>Selecione um operador</option>
                                            {
                                                availableProviders.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0).map((provider, idx) =>
                                                    <option key={`provider-${idx}`} value={provider.id}>{provider.name}</option>
                                                )
                                            }
                                        </FormControl>
                                    </FormGroup>
                                    :
                                    null
                            }

                            <FormGroup controlId="formLine">
                                <ControlLabel>Linha</ControlLabel>
                                {this.renderLines(messageSelected, availableLines)}
                            </FormGroup>

                            <FormGroup controlId="formStop">
                                <ControlLabel>Paragens</ControlLabel>
                                {this.renderPathStops(messageSelected, availablePathStops)}
                            </FormGroup>

                            <FormGroup controlId="formPlataforma" validationState={platformInputError}>
                                <ControlLabel>Plataforma</ControlLabel>
                                <Select
                                    className="custom-multiselect"
                                    placeholder='Selecione uma ou mais plataformas...'
                                    defaultValue={selectDefaultValue}
                                    isMulti={true}
                                    onChange={(e) => this.props.onChangeValue(e, 'platform')}
                                    options={
                                        availablePlatforms.map((plat) => {
                                            return {
                                                value: plat.id,
                                                label: plat.name,
                                            };
                                        })
                                    }
                                />
                                {platformInputError !== null
                                    ?
                                    <HelpBlock> Necessita de selecionar pelo menos uma plataforma. </HelpBlock>
                                    :
                                    null
                                }
                            </FormGroup>

                            <FormGroup controlId="formType" validationState={typeInputError}>
                                <ControlLabel>Tipo</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={messageSelected.type}
                                    placeholder="Introduza o tipo de mensagem"
                                    onChange={(e) => this.props.onChangeValue(e, 'type')}
                                />
                                {typeInputError !== null
                                    ?
                                    <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                    :
                                    null
                                }
                            </FormGroup>

                            <FormGroup controlId="formText" validationState={textInputError}>
                                <ControlLabel>Texto</ControlLabel>
                                <FormControl
                                    componentClass="textarea"
                                    type="text"
                                    value={messageSelected.text}
                                    placeholder="Introduza a mensagem"
                                    onChange={(e) => this.props.onChangeValue(e, 'text')}
                                />
                                {textInputError !== null
                                    ?
                                    <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                    :
                                    null
                                }
                            </FormGroup>

                            <FormGroup controlId="formVersion">
                                <ControlLabel>Versão</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={messageSelected.version}
                                    placeholder="Introduza a versão"
                                    onChange={(e) => this.props.onChangeValue(e, 'version')}
                                />
                            </FormGroup>

                            <FormGroup controlId="formHttpLink">
                                <ControlLabel>Hiperligação</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={messageSelected.httpLink}
                                    placeholder="Introduza a hiperligação"
                                    onChange={(e) => this.props.onChangeValue(e, 'httpLink')}
                                />
                            </FormGroup>

                            <Row>
                                <Col sm={6}>
                                    <FormGroup controlId="formStartDate" validationState={startDateInputError}>
                                        <ControlLabel>Data de Início</ControlLabel>
                                        <DatePicker
                                            id="startDateDatePicker"
                                            dateFormat="DD/MM/YYYY"
                                            value={messageSelected.startDate}
                                            placeholder="Introduza a Data de Início"
                                            onChange={(e) => this.props.onChangeValue(e, 'startDate')} />
                                        {startDateInputError !== null
                                            ?
                                            <HelpBlock> Valor de data inválido. Este campo não pode estar vazio. </HelpBlock>
                                            :
                                            null
                                        }
                                    </FormGroup>
                                </Col>
                                <Col sm={6}>
                                    <FormGroup controlId="formEndDate" validationState={endDateInputError}>
                                        <ControlLabel>Data de Fim</ControlLabel>
                                        <DatePicker
                                            id="endDateDatePicker"
                                            dateFormat="DD/MM/YYYY"
                                            value={messageSelected.endDate}
                                            placeholder="Introduza a Data de Fim"
                                            onChange={(e) => this.props.onChangeValue(e, 'endDate')} />
                                        {endDateInputError !== null
                                            ?
                                            <HelpBlock> Valor de data inválido. Verifique que a data não é anterior à data inicial. </HelpBlock>
                                            :
                                            null
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={4}>
                                    <FormGroup controlId="formCoordX">
                                        <ControlLabel>Coordenada X</ControlLabel>
                                        <FormControl
                                            type="number"
                                            value={messageSelected.coordX}
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={4}>
                                    <FormGroup controlId="formCoordY">
                                        <ControlLabel>Coordenada Y</ControlLabel>
                                        <FormControl
                                            type="number"
                                            value={messageSelected.coordY}
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm={4}>
                                    <FormGroup controlId="formRadius">
                                        <ControlLabel>Raio</ControlLabel>
                                        <FormControl
                                            type="number"
                                            value={messageSelected.radius}
                                            disabled
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <FormGroup controlId="formMap">
                                <Map className="map-container" bounds={this.calculateBounds(messageSelected)} zoom={13} minZoom={7} ondblclick={(e) => this.props.onChangeValue(e, 'dblClick')}>
                                    <TileLayer
                                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />

                                    <FeatureGroup>
                                        <EditControl
                                            position='topright'
                                            onEdited={(e) => this.props.onChangeValue(e, 'circleEdited')}
                                            draw={{
                                                polyline: false,
                                                polygon: false,
                                                rectangle: false,
                                                marker: false,
                                                circlemarker: false,
                                                circle: false,
                                            }}
                                            edit={{
                                                remove: false
                                            }}
                                        />
                                        <Circle center={this.calculateCircleCenter(messageSelected)} radius={messageSelected.radius} />
                                    </FeatureGroup>

                                </Map>
                            </FormGroup>

                        </Form>

                        <ButtonToolbar>
                            <Button onClick={this.props.onSave}> GUARDAR ALTERAÇÕES </Button>
                            <Button onClick={this.props.onHide}> CANCELAR </Button>
                        </ButtonToolbar>

                    </Modal.Body>
                </Modal >
                : null
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/messages/MessageForm.js